/**
 * BlockContainer.js
 * Styled Component for BlockContainer in stepgrid
 */
import styled from 'styled-components'

// Styles
const BlockContainer = styled.div`
    flex-grow: 1;
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    gap: 5px;
`;

export default BlockContainer;